'use strict';

/**
 * A controller used for Payment Setup, both for pre and postpaid.
 * For postpaid the whole topup section is not used.
 */
customerZone.controller('PaymentSetupController', ['$timeout', '$q', '$log', '$filter', '$window',
    'Session', 'SubscriptionService', 'ProductService', 'config', 'utils', 'errorCode', 'ControllerBase',
    function($timeout, $q, $log, $filter, $window, Session, subscriptionService,
        productService, config, utils, errorCode, ControllerBase){

        var DEFAULT_TOPUP_BOUNDARY = 5.00;
        var DEFAULT_PAYMENT_METHOD = 'manual';

        var self = this;
        ControllerBase.call(this, utils);

        self.loading = false;

        // This will be set by handleValidationErrors
        self.uwaValidationErrors = {};

        self.sepaOptions = {
            bic: '',
            iban: ''
        };

        var subscriber = function(){
            return Session.subscriber();
        };

        self.data = {
            paymentMethod: DEFAULT_PAYMENT_METHOD,
            topupProductId: null,
            autoTopupOnLowData: false,
            autoTopupOnExpiry: false,
            autoTopupOnAmount: false,
            autoTopupAmountThreshold: DEFAULT_TOPUP_BOUNDARY
        };

        self.topupProducts = [];
        self.amountThresholdOptions = [
            0, 5.00, 10.00, 15.00, 20.00, 25.00, 30.00, 40.00, 45.00, 50.00, 60.00
        ];
        self.paymentMethods = {};

        self.autoTopupEnabled = function(){
            // TODO: auto-topup: out of scope for now.
            if (!$window.enableAutoTopupForTesting) return false;
            return subscriber() && subscriber().isPrepaid();
        };

        self.autoTopupPossible = function(){
            return self.autoTopupEnabled() && self.data.paymentMethod !== 'manual';
        };

        var topupProduct = function(){
            if (self.data.topupProductId === null) return null;
            return self.topupProducts.find(function(p){ return p.id === self.data.topupProductId; });
        };

        self.describeAutoTopupAmount = function(){
            var threshold = self.data.autoTopupAmountThreshold;
            var autoTopup = topupProduct();
            if (!self.data.autoTopupOnAmount || threshold === undefined || !autoTopup) return '';
            threshold = $filter('amountEuro')(threshold);
            var autoTopupAmount = $filter('amountEuro')(autoTopup.price);
            return utils.format('describe_autotopup_for_{amount}_using_{method}_when_below_{boundary}',
                {amount: autoTopupAmount, method: self.paymentMethods[self.data.paymentMethod].description,
                    boundary: threshold});
        };

        self.describeAutoTopupExpires = function(){
            if (!self.data.autoTopupOnExpiry) return '';
            var autoTopup = topupProduct();
            if (!autoTopup) return '';
            var autoTopupAmount = $filter('amountEuro')(autoTopup.price);
            return utils.format('describe_autotopup_for_{amount}_using_{method}_when_bundle_about_to_expire',
                {amount: autoTopupAmount, method: self.paymentMethods[self.data.paymentMethod].description});
        };

        self.describeAutoTopupLowData = function(){
            if (!self.data.autoTopupOnLowData) return '';
            var autoTopup = topupProduct();
            if (!autoTopup) return '';
            var autoTopupAmount = $filter('amountEuro')(autoTopup.price);
            return utils.format('describe_autotopup_for_{amount}_using_{method}_when_data_almost_gone',
                {amount: autoTopupAmount, method: self.paymentMethods[self.data.paymentMethod].description});
        };

        self.init = function(){

            self.loading = utils.translate('loading_data');

            var setupPromise = $q.when({});
            var productPromise = $q.when([]);

            if (self.autoTopupEnabled()) {
                setupPromise = subscriptionService.getPaymentSetup(Session.subscriber().id)
                    .then(function (setup) {
                        self.data.autoTopupOnAmount = setup.autoTopup && setup.autoTopup.onAmountThreshold;
                        self.data.autoTopupOnLowData = setup.autoTopup && setup.autoTopup.onLowData;
                        self.data.autoTopupOnExpiry = setup.autoTopup && setup.autoTopup.onBundleExpiry;
                        self.data.autoTopupAmountThreshold = setup.autoTopup ? setup.autoTopup.amountThreshold : null;
                        if (setup.autoTopup) self.data.topupProductId = setup.autoTopup.topupProductId;

                        if (!self.data.autoTopupAmountThreshold)
                            self.data.autoTopupAmountThreshold = DEFAULT_TOPUP_BOUNDARY;
                    });

                productPromise = productService.getTopupProducts()
                    .then(function (topups) {
                        self.topupProducts = topups;
                        if (!self.data.topupProductId)
                            self.data.topupProductId = topups.length === 0 ? null : topups[0].id;
                    });
            }

            var invoiceSettingsPromise = subscriptionService.getInvoicingSettings(Session.subscriber().id)
                .then(function(setup){
                    self.data.invoicingAddress = setup.invoicingAddress;
                    self.data.billingPreference = setup.billingPreference;
                    self.useMainAddress = !self.data.invoicingAddress || angular.equals(self.data.invoicingAddress,
                        Session.profile().address);
                    if (self.useMainAddress)
                        self.syncAddress();
                });

            var mandatePromise = loadPaymentMethods();

            $q.all([setupPromise, productPromise, mandatePromise, invoiceSettingsPromise])
                .then(function(){
                    self.loading=false;
                }, function(error){
                    self.loading=false;
                    self.error=true;
                    $log.error('Error initializing paymentSetupController (settings, product, mandate or ' +
                        'autoTopupSetup promise rejected)', error);
                    utils.showError();
                });
        };

        self.save = function () {
            if (self.loading) return;

            var updatePromise =
                applyInvoicingSettings()
                    .then(applyAutoTopup)
                    .then(applyPaymentMethod)
                    .then(function(result){
                        if (result.paymentUrl) {
                            busy.freeze();
                            utils.redirect(result.paymentUrl);
                        }
                        else {
                            return loadPaymentMethods();
                        }
                    }).catch(function(error){
                        if (errorCode.is(error, errorCode.MANDATE_UNSETTABLE) ||
                            errorCode.is(error, errorCode.MANDATE_INFO_MISSMATCH)) {

                            if (errorCode.is(error, errorCode.MANDATE_INFO_MISSMATCH)) {
                                self.handleValidationErrors(
                                    error,
                                    [{code: errorCode.MANDATE_INFO_MISSMATCH,
                                        on: 'sepaIban',
                                        message: 'debtor_bic_iban_mismatch'}],
                                    busy
                                );
                            }
                            busy.showError('unsettable_mandate');
                        }
                        throw error;
                    });

            var busy = utils.showBusy(
                updatePromise,
                'update_pending',
                'your_payment_method_has_been_changed');

            return busy.wrappedPromise;
        };

        var loadPaymentMethods = function(){
            return subscriptionService.getPaymentMethods(Session.subscriber().id)
                .then(function(methods){
                    self.paymentMethods = methods;
                    Object.keys(self.paymentMethods).forEach(function(methodKey){
                        if (self.paymentMethods[methodKey].active)
                            self.data.paymentMethod = methodKey;
                    });
                });
        };

        self.requireBillingAddress = function(){
            return self.data.billingPreference === 'paper';
        };

        self.syncAddress = function(){

            if (!Session.subscriber()) {
                $log.debug('no subscription');
                self.error = true;
                jim.goHome();
                return;
            }

            if (self.useMainAddress) {
                self.data.invoicingAddress = {
                    company: Session.profile().company,
                    firstName: Session.profile().firstName,
                    lastName: Session.profile().lastName,
                    address: Session.profile().address
                };
            }
            else {
                self.data.invoicingAddress = {address: {country: 'be'}};
            }
        };

        var applyInvoicingSettings = function(){
            if (!subscriber().isPostpaid()) return $q.when();

            return subscriptionService.setInvoicingSettings(Session.subscriber().id, {
                billingPreference: self.data.billingPreference,
                invoicingAddress: self.data.invoicingAddress
            });
        };

        var applyAutoTopup = function(){
            if (!self.autoTopupEnabled())
                return $q.when();
            return subscriptionService.setAutoTopup(Session.subscriber().id, buildTopupOptions());
        };

        var applyPaymentMethod = function(){
            return self.paymentMethods[self.data.paymentMethod].apply(utils.currentPath(),
                self.sepaOptions);
        };

        var buildTopupOptions = function() {
            if (subscriber().isPostpaid()) return undefined;
            var topupOptions = {};
            topupOptions.onAmountThreshold = self.data.autoTopupOnAmount === true;
            topupOptions.onBundleExpiry = self.data.autoTopupOnExpiry === true;
            topupOptions.onLowData = self.data.autoTopupOnLowData === true;
            topupOptions.productId = self.data.topupProductId;
            topupOptions.amountThreshold = self.data.autoTopupAmountThreshold;
            return topupOptions;
        };

        self.init();

    }]);

